export default "__VITE_ASSET__eWO3Xtuy__"